import React from "react";
import {
  CardsWrapper,
  ContentLeft,
  FilterWrapper,
  GeneralContainer,
  SearchField,
} from "./ResourcesManagerTabs.styled";
import Paper from "@material-ui/core/Paper";
import SearchIcon from "@material-ui/icons/Search";
import { Form } from "react-bootstrap";
import { AntTabs, AntTab } from "../../helpers/antTabs";

const ResourcesManagerTabs = ({
  setSelectMenu,
  setValueTabs,
  valueTabs,
  searchTxt,
  setSearchTxt,
  setrenderAgain,
  renderAgain,
}) => {
  return (
    <>
      <GeneralContainer>
        <Paper position="static">
          <AntTabs aria-label="Resources" value={valueTabs}>
          <AntTab
              label="About Wellness"
              id="1"
              onClick={() => {
                setSelectMenu(["AboutWellness"]);
                setValueTabs(0);
              }}
            />
            <AntTab
              label="Surveys"
              id="2"
              onClick={() => {
                setSelectMenu(["Surveys"]);
                setValueTabs(1);
              }}
            />
            <AntTab
              label="Calendar"
              id="3"
              onClick={() => {
                setSelectMenu(["Calendar"]);
                setValueTabs(2);
              }}
            />
            <AntTab
              label="Coaches"
              id="4"
              onClick={() => {
                setSelectMenu(["Coaches"]);
                setValueTabs(3);
              }}
            />
            <AntTab
              label="Engagement"
              id="5"
              onClick={() => {
                setSelectMenu(["Engagement"]);
                setValueTabs(4);
              }}
            />
            <AntTab
              label="Gamification"
              id="6"
              onClick={() => {
                setSelectMenu(["Gamification"]);
                setValueTabs(5);
              }}
            />
            
          </AntTabs>
          
        </Paper>
        <CardsWrapper style={{ visibility: "hidden" }} className="pt-3 pb-2">
          <ContentLeft></ContentLeft>
          <FilterWrapper>
            <SearchField>
              <SearchIcon />
              <Form.Control
                type="text"
                placeholder="Search"
                value={searchTxt}
                onChange={(e) => {
                  setSearchTxt(e.target.value);
                }}
                onBlur={() => setrenderAgain(!renderAgain)}
              />
            </SearchField>
          </FilterWrapper>
        </CardsWrapper>
      </GeneralContainer>
    </>
  );
};

export default ResourcesManagerTabs;
